const values = [
  {
    icon: "ri-compasses-2-line",
    title: "专注阅读体验",
    text: "我们相信读漫画是纯粹的快乐，把书签、同步、历史这些琐事做到无需操心。",
  },
  {
    icon: "ri-shield-check-line",
    title: "数据安全可靠",
    text: "阅读进度与收藏全程加密存储传输，跨设备同步稳定，你的阅读足迹只属于你。",
  },
  {
    icon: "ri-book-2-line",
    title: "内容多元有趣",
    text: "从热血到治愈、从悬疑到恋爱，持续为你网罗值得一读的精品漫画。",
  },
];

export default function About() {
  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于尾巴漫画网",
    description:
      "尾巴漫画网是主打阅读书签与跨设备同步的漫画阅读平台，支持历史记录、断点续读与收藏同步。",
  };

  return (
    <section id="about" className="bg-background-100 py-16 md:py-24">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
      />
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-800">
              <i className="ri-information-line"></i>
              关于我们
            </span>
            <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
              尾巴漫画网，让每一段阅读都不断档
            </h2>
            <p className="mt-4 leading-relaxed text-foreground-700">
              尾巴漫画网诞生于一个朴素的想法：换手机、换平板，不该成为追更的阻碍。
              我们把阅读书签、历史记录、阅读足迹与收藏同步做成最顺手的样子，
              让读者无论在哪个屏幕前停下，都能从原处继续。
            </p>
            <p className="mt-3 leading-relaxed text-foreground-700">
              从最初的小工具到如今多端协同的漫画阅读平台，我们始终围绕"断点续读"这一件事深耕，
              希望每一次打开尾巴漫画网，都是一次无缝衔接的沉浸之旅。
            </p>
            <div className="mt-6 flex flex-col gap-2 text-sm text-foreground-700">
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-600"></i>
                contact@weibamanga.com
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-global-line text-primary-600"></i>
                www.weibamanga.com
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-1">
            {values.map((item) => (
              <div
                key={item.title}
                className="flex items-start gap-4 rounded-2xl border border-background-200 bg-background-50 p-5"
              >
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-xl text-primary-700">
                  <i className={item.icon}></i>
                </div>
                <div>
                  <h3 className="font-heading text-lg text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-700">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}